export default "__VITE_ASSET__B_khX$Hy__"